module.exports = __webpack_public_path__ + "media/images/message2-b29333c311fb628d0b496839188392b5.svg";